export default "../css/230fa25c28f877cb6e43e75e6dfe711e.ttf";